export default function Center(props) {
    return (
        <div className="limiter" >
            <div className="container flex-center">
                {props.children}
            </div>
        </div>
    )
}